import React from "react";

const RefferelRoute = ({ children }) => {
    return children;
};

export default RefferelRoute;
